
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/overview",
      function () {
        return require("private-next-pages/analytics/overview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/overview"])
      });
    }
  